import { useCallback } from 'react';

import { setCookie } from '@mindtickle/utils/cookies';

import { DEFAULT_COOKIE_EXPIRATION_DURATION, DEFAULT_COOKIE_VALUE } from '../constants';
import { BannerData, MaintenanceBannerData } from '../types';

export const useMaintenance = (
  bannerData: MaintenanceBannerData,
  setBannerData: Function,
  route: string
): [() => void] => {
  const { cookieName, bannerHideDurationSeconds = DEFAULT_COOKIE_EXPIRATION_DURATION } = bannerData;

  const onMaintenanceClose = useCallback(() => {
    setCookie(
      cookieName,
      DEFAULT_COOKIE_VALUE,
      bannerHideDurationSeconds / DEFAULT_COOKIE_EXPIRATION_DURATION
    );
    setBannerData((prevData: Record<string, BannerData>) => {
      const newData = { ...prevData };
      delete newData[route];
      return { ...newData };
    });
  }, [cookieName, bannerHideDurationSeconds, setBannerData, route]);

  return [onMaintenanceClose];
};

export default useMaintenance;
